import { render, staticRenderFns } from "./TaxiTransactionsHistory.vue?vue&type=template&id=5c33f8bd&scoped=true"
import script from "./TaxiTransactionsHistory.vue?vue&type=script&lang=js"
export * from "./TaxiTransactionsHistory.vue?vue&type=script&lang=js"
import style0 from "./TaxiTransactionsHistory.vue?vue&type=style&index=0&id=5c33f8bd&prod&lang=scss&scoped=true"
import style1 from "./TaxiTransactionsHistory.vue?vue&type=style&index=1&id=5c33f8bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c33f8bd",
  null
  
)

export default component.exports